import {
  EmployeeLiteModel,
  EmployeeModel,
  getEmployeeKey,
  getEmployeesKey,
  useGetEmployee,
  useGetEmployees,
} from 'api-hooks/employee';
import { Option } from 'baseui/select';
import { ModelTransformer } from 'common/helpers/common';

import { ColumnDataType } from '../type';

export function employeeTransformer(
  item: EmployeeLiteModel | EmployeeLiteModel,
): Option {
  return {
    id: item.id,
    label: [item.username, item.name].join(' - '),
    extra: item,
  };
}

const employeeColumn = {
  dataType: ColumnDataType.select,
  useListQueryHook: useGetEmployees,
  useDetailLazyQueryHook: useGetEmployee,
  listKeyFunction: getEmployeesKey,
  detailKeyFunction: getEmployeeKey,
  getMemoizedListVariables: (page, q) => ({
    params: {
      q,
      page,
    },
  }),
  getMemoizedDetailVariables: (value: string) => ({
    id: value,
  }),
  listTransformer: (result) => {
    return result.data.map((v) => {
      const data = ModelTransformer(v, EmployeeLiteModel);
      return employeeTransformer(data);
    });
  },
  detailTransformer: (result) => {
    const data = ModelTransformer(result.data, EmployeeModel) as EmployeeModel;
    return employeeTransformer(data);
  },
  paginationTransformer: (result) => {
    return result.meta;
  },
  filterOptions: null,
};

export default employeeColumn;
